import AppIcon from "@/common/components/Icons/AppIcon";
import { useApiRequest } from "@/common/hooks/api/useApiRequest";
import { apiClient } from "@/core/api/ApiClient";
import { ChargeDto, ChargeReferenceDto } from "@/core/api/generated/v1";

import BaseEntityInline, {
  BaseEntityInlineInheritableProps,
} from "../components/EntityInline/BaseEntityInline";
import { getChargeOptionTitle } from "./ChargeAutocomplete";

export interface ChargeInlineProps extends BaseEntityInlineInheritableProps {
  entity: ChargeDto | ChargeReferenceDto | null | undefined;
  entityId?: string | null;
}

/** Inline brief information about the charge. */
export default function ChargeInline({
  entity,
  entityId,
  fetch = true,
  ...otherProps
}: ChargeInlineProps) {
  const request = useApiRequest(
    apiClient.chargesApi.apiV1ChargesChargeIdGet,
    {
      nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
      chargeId: entityId!,
    },
    {
      deps: [entityId],
      skip: !fetch || !entityId || !!entity,
    },
  );
  entity = request?.data || entity;

  const full = entity as ChargeDto;
  // const ref = entity as ChargeReferenceDto;

  return (
    <BaseEntityInline
      entity={entity}
      entityId={entityId}
      request={fetch ? request : undefined}
      icon={<AppIcon of='charge' inText />}
      content={
        <>
          {full && getChargeOptionTitle(full)}
          {!full && <>Charge</>}
        </>
      }
      {...otherProps}
      tooltipTitle={otherProps?.tooltipTitle || "Charge"}
    />
  );
}
